import React from 'react'

import { Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { SmallText } from '../../../../../packages/kiti/components/presentation/Text'
import { SubItem, SubItemsWrapper } from '../../../../../components/structure/SubItems'
import { getQueryParam } from '../../../../../utils/helpers/url'
import { useIsDraggingItem } from '../../../../../components/dnd/DndHandler'
import Icon from '../../../../../packages/kiti/components/shapes/Icon'
import QuestionsList from './QuestionsList'
import Separator from '../../../../../components/helpers/Separator'

const DirectChildren = ({ question }) => {
  const [open, setOpen] = React.useState(getQueryParam('startsClosed') !== 'true')
  const toggle = () => setOpen(!open)
  const isDraggingQuestion = useIsDraggingItem(question.reference)

  if (question.questionType?.name !== 'block' || isDraggingQuestion) return false

  return (
    <SubItemsWrapper>
      <div>
        <Separator weight={2} />

        <SubItem noLine>
          <Grid align="center">
            <Icon name={open ? 'BsCaretDownSquare' : 'BsCaretRightSquare'} color="dark3" onClick={toggle} />
            <Separator weight={2} vertical />
            <SmallText>Perguntas do bloco</SmallText>
          </Grid>
        </SubItem>

        {open && (
          <>
            <Separator weight={2} />

            <QuestionsList questions={question.children} parentReference={question.reference} isSubItems />

            <Separator weight={2} />
          </>
        )}
      </div>

      <Separator weight={2} />
    </SubItemsWrapper>
  )
}

export default DirectChildren
